import { Box, Container } from '@mui/material';
import classNames from 'classnames';
import { ClipboardEvent, FC, ReactNode, useCallback, useLayoutEffect } from 'react';

import styles from './PolicyContainer.module.scss';

type PolicyContainerProps = {
  className?: string;
  children?: ReactNode;
};

export const PolicyContainer: FC<PolicyContainerProps> = (props) => {
  const { className, children } = props;

  const handleCopy = useCallback((e: ClipboardEvent) => {
    e.preventDefault();
  }, []);

  useLayoutEffect(() => {
    const listener = (e: MouseEvent) => {
      e.preventDefault();
    };

    window.addEventListener('contextmenu', listener);

    return () => window.removeEventListener('contextmenu', listener);
  }, []);

  return (
    <Box className={classNames(styles.textWrapper, className)}>
      <Container maxWidth={'md'} sx={{ margin: '56px auto' }} onCopy={handleCopy}>
        {children}
      </Container>
    </Box>
  );
};
